import React from "react";
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class Overlay extends React.Component
{
    static propTypes = {
        active: PropTypes.bool,
        onClick: PropTypes.func,
    };

    static defaultProps = {
        active: false,
    };

    render()
    {
        const className = classNames({
            "absolute inset-0 z-10 cursor-pointer": true,

            "border-2 border-indigo-400 border-opacity-0": true,
            "hover:border-opacity-75": ! this.props.active,
            "border-opacity-100": this.props.active,
        });

        return <div className={className} onClick={this.props.onClick} />;
    }
}
